<div class="container-fluid tw-relative tw-bg-white tw-pb-12 tw-overflow-hidden">
  <!-- Fondo decorativo inferior derecho -->
  <div
    class="tw-absolute tw-inset-0 tw-bg-no-repeat tw-bg-right-bottom tw-bg-[url('/assets/images/logoOrange.png')] tw-opacity-10 tw-blur-xs tw-z-0 tw-pointer-events-none tw-hidden md:tw-block"
    style="background-size: 280px;"
  ></div>

  <!-- Elipsis decorativo superior izquierdo más centrado -->
 <div
  class="tw-absolute tw-left-0 tw-top-56 tw-w-[900px] tw-h-[900px] tw-z-0 tw-pointer-events-none tw-hidden md:tw-block"
  style="background: radial-gradient(circle at top left, rgba(246, 112, 17, 0.25) 0%, transparent 70%); filter: blur(40px);"
></div>



  <!-- Contenido principal -->
  <div class="tw-relative tw-z-10">
    <!-- Encabezado -->
    <div class="tw-max-w-6xl tw-mx-auto tw-px-4">
      <h2 class="tw-text-center tw-text-4xl md:tw-text-5xl tw-font-montserrat tw-font-bold tw-pt-12 tw-pb-4 tw-leading-tight">
        <span class="tw-text-black">
          CONÉCTATE A
          <span class="tw-text-[#F67011] tw-drop-shadow-md">NUESTROS PLANES</span>
          DE FIBRA
        </span>
      </h2>
      <p class="tw-text-center tw-text-xl tw-font-montserrat tw-font-light tw-text-gray-800 tw-mt-2 tw-mb-8 tw-leading-relaxed">
        <span class="tw-text-[#F67011] tw-font-bold"> Onelink</span> ofrece
        <span class="tw-font-medium tw-text-black">un servicio prepago y sin complicaciones, sin cláusulas</span>,
        ni cargos ocultos para reactivar tu conexión, con planes asimétricos diseñados para una experiencia óptima garantizada.
        
      </p>
    </div>

    <!-- Grid de tarjetas -->
    <div class="tw-max-w-6xl tw-mx-auto tw-px-4 tw-py-2">
      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-2 tw-gap-6 tw-mt-4">
        <app-card-price  [plan]="'500'" [text]="'Navega, haz streaming en HD y usa redes sociales fácilmente.'" [price]="'30'"></app-card-price>
        <app-card-price [plan]="'800'" [text]="'Ideal para navegación, streaming en 4K y videojuegos en línea.'" [price]="'38'"></app-card-price>
        <app-card-price [plan]="'900'" [text]="'Disfruta de alto rendimiento en hogares con múltiples dispositivos.'" [price]="'52'"></app-card-price>
        <app-card-price [plan]="'1500'" [text]="'Ideal para streaming, descargas y trabajo remoto sin límites.'" [price]="'88'"></app-card-price>
      </div>
    </div>

  
  </div>
</div>
